import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import AppRouter from './AppRouter';
import rootReducer from './reducers';
import { verifyAuth } from './actions';
import './App.css';
import { MuiThemeProvider } from 'material-ui/styles';
import  "./axiosConfigs/axiosInstance";

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware)); //redux & middleware

function App() {

  useEffect(() => {
     var unsubscribe = store.dispatch(verifyAuth());
     return function cleanup() {
       unsubscribe(); // unsubscribe auth listener to prevent memory leak
     };
  }, []); // only run once

  return (
    <MuiThemeProvider>
    <Provider store={store}>
      <AppRouter />
      <div className="version-text">Version: 1.1.18</div>
    </Provider>
    </MuiThemeProvider>
  );
}

export default App;
